module.exports = __webpack_public_path__ + "static/img/ruit-mint-foto.494be30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ruit-mint-foto.png
// module id = uG+0
// module chunks = 0